import { Injectable } from '@angular/core';
import { Day, Month, Year } from '@shared/interfaces/datetime.interface';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from '@shared/services/storage.service';
import * as moment from 'moment';
import { Config } from '@shared/config';
import { Project } from '@shared/models/project.model';

@Injectable({
  providedIn: 'root',
})
export class DatetimeService {
  static DAYS: Day[] = [];
  static MONTHS: Month[] = [];
  static MONTHS_LENGTH: number = 12;
  static YEARS: Year[] = [];
  static END_YEAR: number = 2020;
  static START_YEAR: number = 1920;

  constructor(public translate: TranslateService, public storage: StorageService) {}

  setDays(month, year) {
    DatetimeService.DAYS = [];
    const monthValue = +month < 10 ? '0' + month : month;
    const days = moment(year + '-' + monthValue).daysInMonth();
    for (let i = 1; i <= days; i++) {
      DatetimeService.DAYS.push({
        id: i,
        value: i,
      });
    }
    return DatetimeService.DAYS;
  }

  setMonths() {
    DatetimeService.MONTHS = [];
    for (let i = 1; i <= DatetimeService.MONTHS_LENGTH; i++) {
      DatetimeService.MONTHS.push({
        name: this.translate.instant('MONTHS.month_' + i),
        value: i,
      });
    }
    return DatetimeService.MONTHS;
  }

  setYears() {
    DatetimeService.YEARS = [];
    for (let i = DatetimeService.END_YEAR; i >= DatetimeService.START_YEAR; i--) {
      DatetimeService.YEARS.push({
        id: i,
        value: i,
      });
    }
    return DatetimeService.YEARS;
  }

  formatDate(day: number, month: number, year: number) {
    const date_day = day < 10 ? '0' + day : day;
    const date_month = month < 10 ? '0' + month : month;
    const date = year + '-' + date_month + '-' + date_day;
    return this.getDate(date, Config.DATE_FORMAT_BACKEND, true).format(Config.DATE_FORMAT_BACKEND);
  }

  get birthYear() {
    return this.storage.user.birthday.split('-')[0];
  }

  get birthMonth() {
    return this.storage.user.birthday.split('-')[1];
  }

  get birthDay() {
    return this.storage.user.birthday.split('-')[2];
  }

  getDate(date, format, withLang) {
    return withLang ? moment(date, format, this.storage.getLang()) : moment(date, format);
  }

  getProjectEndDaysLeft(project: Project) {
    let daysLeft = null;
    if (project.days_to_end) {
      if (project.main_page_add_date) {
        daysLeft = moment(project.main_page_add_date, Config.DATE_FORMAT_BACKEND).add(
          project.days_to_end,
          'days'
        );
        return daysLeft.diff(moment(), 'days');
      }
      return project.days_to_end;
    }
    return '-';
  }
}
